import React from "react";
import KioskStartButton from "../components/start-button";

export default function WeightDisplayScreen({
  navigate,
  weight,
  estimate,
  setInputWeight,
}) {
  return (
    <div className="flex flex-col items-center justify-between w-full h-full relative">
      <div className="flex flex-col px-[3vh] relative z-10">
        <p className="text-[60px] text-black text-center mt-[2vh]">
          Ka-ching! Your LEGO® bricks <br />
          weigh in at:
        </p>

        <div className="flex justify-between pt-8">
          {/* Weight display */}
          <div className="flex flex-col mr-[120px] items-center">
            <div className="flex w-full justify-center">
              <div className="w-[60px] h-[30px] bg-blue relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-blue relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-blue relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-blue relative -bottom-1"></div>
            </div>
            <div className="flex bg-blue items-baseline text-white w-[370px] justify-center">
              <div className="text-[90px]">{weight.toFixed(2)}</div>
              <div className="text-[50px] ml-[1vh]">lbs</div>
            </div>
            <div className="text-[24px] pt-4">Package weight</div>
          </div>

          {/* Value estimate display */}
          <div className="flex flex-col items-center">
            <div className="flex w-full justify-center">
              <div className="w-[60px] h-[30px] bg-green relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-green relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-green relative -bottom-1 mr-[30px]"></div>
              <div className="w-[60px] h-[30px] bg-green relative -bottom-1"></div>
            </div>
            <div className="flex bg-green text-white w-[370px] justify-center">
              <div className="text-[32px] mr-[0.8rem] mt-[1vh]">$</div>
              <div className="text-[90px]">{estimate.gift}</div>
            </div>
            <div className="text-[24px] pt-4">As a LEGO e-Gift Card</div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-[48px] px-[4vh] relative z-10 mb-[4vh]">
        <KioskStartButton
          onClick={() => {
            setInputWeight(0);
            navigate("holding");
          }}
          icon="close"
        >
          Cancel
        </KioskStartButton>

        <KioskStartButton
          className="font-semibold"
          onClick={() => navigate("qrCode")}
          icon="arrow_forward"
          iconColor="black"
          color="yellow"
        >
          Continue
        </KioskStartButton>
      </div>
    </div>
  );
}
